import { render, staticRenderFns } from "./appointmentsFilter.vue?vue&type=template&id=27d1f66e&scoped=true"
import script from "./appointmentsFilter.vue?vue&type=script&lang=ts"
export * from "./appointmentsFilter.vue?vue&type=script&lang=ts"
import style0 from "./appointmentsFilter.vue?vue&type=style&index=0&id=27d1f66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1f66e",
  null
  
)

export default component.exports